
import TripDetailPage from "../../pages/dashboard/trips/TripDetailPage";
import TripsPage from "../../pages/dashboard/trips/TripsPage";

export const TripRoutes = [
  {
    name: "Chuyến đi",
    path: "",
    element: <TripsPage />,
  },
  {
    name: "Chi tiết vé",
    path: ":id",
    element: <TripDetailPage />,
  },
];
